import { dateTime, meso } from './format';

const price = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
});

/** Formats market prices and derived percentile values. Prices are per item. */
export function formatPrice(value: number): string {
  return price.format(value);
}

export function formatIntegerMeso(value: number): string {
  return meso.format(value);
}

export function formatObservationRange(start: number, end: number): string {
  if (start === end) return dateTime.format(start);
  return `${dateTime.format(start)} – ${dateTime.format(end)}`;
}
